import { RestService } from '../restService';
import { Coachee } from '../../models';

export class CoacheeService extends RestService<Coachee> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }

    // Backend route: GET /coachee/coacheeId/:id
    public async get(id: string): Promise<Coachee> {
        const realClient = await this.axiosFactory();
        const response = await realClient.request<Coachee>({
            method: 'GET',
            url: `/coacheeId/${id}`,
        });
        return response?.data as Coachee;
    }

    // Backend route: GET /coachee/all/:creator
    public async getByCreator(creatorEmail: string): Promise<Coachee[]> {
        if (!creatorEmail) return [];
        const realClient = await this.axiosFactory();
        const response = await realClient.request<Coachee[]>({
            method: 'GET',
            url: `/all/${creatorEmail}`,
        });
        return response?.data || [];
    }

    public async recalculateCompletedHours(clientId: string): Promise<void> {
        const realClient = await this.axiosFactory();
        await realClient.request<void>({
            method: 'POST',
            url: `${clientId}/completed`,
        });
    }

    public async purge(clientId: string): Promise<void> {
        const realClient = await this.axiosFactory();
        await realClient.request<void>({
            method: 'DELETE',
            url: `${clientId}/purge`,
        });
    }
}
